import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  selectedTeamSelector,
  uiStateSelector
} from 'state/selectors/ui-state';
import CycleTime from '../../components/CycleTime';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import {
  getCycleTimeConfigurations,
  goToBranchesOrderBy
} from '../../dashboard.service';
import { StyledCycleTimeWrapper } from './CycleTImeWidget.style';
import { metricNames } from '@linearb/linjs-common';

const CycleTimeWidget = ({
  cycleTimeTrendData,
  cycleTimeAverage,
  totalCycleTimeInMinutes,
  pipelineMilestones,
  isLodingCycleTimeData
}) => {
  const uiState = useSelector(uiStateSelector);
  const history = useHistory();
  const selectedTeam = useSelector(selectedTeamSelector);

  const { dates, selectedTeamId } = uiState;

  return (
    <StyledCycleTimeWrapper data-testid='freePlusCycleTime'>
      <CycleTime
        value={totalCycleTimeInMinutes}
        trendData={cycleTimeTrendData}
        selectedTeamId={selectedTeamId}
        onLinkIconClick={() => {
          TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
            page: TRACKING.PAGES.DASHBOARD,
            click_type: TRACKING.CLICK.CYCLE_TIME_CONTEXT
          });
          goToBranchesOrderBy(
            'cycle_time,desc',
            uiState,
            selectedTeam,
            history,
            metricNames.CYCLE_TIME,
            'cycle_time_updated'
          );
        }}
        configurations={getCycleTimeConfigurations(pipelineMilestones)}
        avgTime={cycleTimeAverage}
        dates={dates}
        isLodingCycleTimeData={isLodingCycleTimeData}
        hideTrendData={true}
      />
    </StyledCycleTimeWrapper>
  );
};

export default CycleTimeWidget;
